/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import * as getHelpers from '../../modules/auth/GetHelpers'
import { ComponentLoading } from '../../modules/ComponentLoading'
import * as getUserInfo from '../../modules/auth/GetUserInfo'
import axios from 'axios'
import { useNavigate, Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const API_URL = process.env.REACT_APP_API_URL
const ApiToken = localStorage.getItem('api_token')
const BearerToeken = `Bearer ${ApiToken}`
const recentDashboardsUrl = `${API_URL}/internal/recent-dashboards`
const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/v1/authentication/user/verify_access`
type Props = {
    className: string
}

const RecentDashboards: React.FC<Props> = ({ className }) => {

    const [getRecentDashboards, setRecentDashboards] = useState<any[]>([]);
    const [getComponentLoading, setComponentLoading] = useState(true)
    const navigate = useNavigate();
    useEffect(() => {
        const config = {
            headers: { Authorization: BearerToeken }
        };
        axios.get(
            GET_USER_BY_ACCESSTOKEN_URL,
            config
        )
            .then(async (res) => {
                if (res.data.status) {
                    if (res.data.userType == 'external') {
                        navigate('/error/404')
                    }
                } else if (res.data.userType == 'User type not found') {
                    if (getUserInfo.userType() == 'external') {
                        navigate('/error/404')
                    }
                }
            })
            .catch((error) => {
                navigate('/error/404')
            });
        fetchRecentDashboards()

    }, [])
    const fetchRecentDashboards: any = () => {
        const config = {
            headers: { Authorization: BearerToeken }
        };
        const recentCustomersList = axios.get(
            recentDashboardsUrl,
            config
        )
            .then(async (res: any) => {

                setRecentDashboards(res.data.dashboards)
                setComponentLoading(false)
            })
            .catch((error) => {
                console.log(error)
                setComponentLoading(false)
            });
        return recentCustomersList

    }
    return (
        <div className={`card ${className} overflow-hidden`}>

            {
                getComponentLoading ?
                    (
                        <ComponentLoading></ComponentLoading>
                    ) : ('')
            }
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1 heading_f'>Recent Dashboards </span>
                    <span className='text-muted mt-1 fw-semibold fs-7'>List of Dashboards</span>
                </h3>
                <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                    title='Click to add a user'
                >
                </div>
            </div>
            {
                getRecentDashboards.length > 0 ?
                    (
                        <>
                            <div className='card-body py-3'>
                                <div className='table-responsive'>
                                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                        <tbody>
                                            {getRecentDashboards.map((workspaceObj) => (
                                                <tr key={workspaceObj._id}>
                                                    <td>
                                                        <span className='fw-bolder'>
                                                            {workspaceObj.name}
                                                        </span>
                                                    </td>
                                                    {/* <td width={100}>
                                                        <span className="badge badge-success">
                                                            {workspaceObj.status}
                                                        </span>
                                                    </td> */}
                                                    <td width={100}>
                                                        <div className='d-flex justify-content-end flex-shrink-0'>
                                                            {/* <a
                                                                className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                                            >
                                                                <Link to={'/internal/organizations/' + workspaceObj._id} className='text-gray-600'>
                                                                    <KTSVG
                                                                        path='/media/icons/duotune/arrows/arr064.svg'
                                                                        className='svg-icon-2'
                                                                    />
                                                                </Link>
                                                            </a> */}
                                                            <div className='customActionButtons'>
                                                            <OverlayTrigger placement={'top'} overlay={<Tooltip className='fw-bolder'>View</Tooltip>}>
                                                                <Link className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1' to={'/dashboard/' + workspaceObj._id} >
                                                                {/* <i className="bi bi-eye"></i> */}
                                                                <span className="svg-icon svg-icon-muted svg-icon-18"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M21.7 18.9L18.6 15.8C17.9 16.9 16.9 17.9 15.8 18.6L18.9 21.7C19.3 22.1 19.9 22.1 20.3 21.7L21.7 20.3C22.1 19.9 22.1 19.3 21.7 18.9Z" fill="currentColor" />
                                                                    <path opacity="0.3" d="M11 20C6 20 2 16 2 11C2 6 6 2 11 2C16 2 20 6 20 11C20 16 16 20 11 20ZM11 4C7.1 4 4 7.1 4 11C4 14.9 7.1 18 11 18C14.9 18 18 14.9 18 11C18 7.1 14.9 4 11 4ZM8 11C8 9.3 9.3 8 11 8C11.6 8 12 7.6 12 7C12 6.4 11.6 6 11 6C8.2 6 6 8.2 6 11C6 11.6 6.4 12 7 12C7.6 12 8 11.6 8 11Z" fill="currentColor" />
                                                                </svg>
                                                                </span>
                                                                </Link>
                                                            </OverlayTrigger>
                                                            <OverlayTrigger placement={'top'} overlay={<Tooltip className='fw-bolder'>Edit</Tooltip>}>
                                                                <Link className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1' to={'/dashboard/' + workspaceObj._id + '/edit'} >
                                                                {/* <i className="bi bi-pencil-square"></i> */}
                                                                <span className="svg-icon svg-icon-muted svg-icon-18"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M2 4.63158C2 3.1782 3.1782 2 4.63158 2H13.47C14.0155 2 14.278 2.66919 13.8778 3.04006L12.4556 4.35821C11.9009 4.87228 11.1726 5.15789 10.4163 5.15789H7.1579C6.05333 5.15789 5.15789 6.05333 5.15789 7.1579V16.8421C5.15789 17.9467 6.05333 18.8421 7.1579 18.8421H16.8421C17.9467 18.8421 18.8421 17.9467 18.8421 16.8421V13.7518C18.8421 12.927 19.1817 12.1387 19.7809 11.572L20.9878 10.4308C21.3703 10.0691 22 10.3403 22 10.8668V19.3684C22 20.8218 20.8218 22 19.3684 22H4.63158C3.1782 22 2 20.8218 2 19.3684V4.63158Z" fill="currentColor" />
                                                                    <path d="M10.9256 11.1882C10.5351 10.7977 10.5351 10.1645 10.9256 9.77397L18.0669 2.6327C18.8479 1.85165 20.1143 1.85165 20.8953 2.6327L21.3665 3.10391C22.1476 3.88496 22.1476 5.15129 21.3665 5.93234L14.2252 13.0736C13.8347 13.4641 13.2016 13.4641 12.811 13.0736L10.9256 11.1882Z" fill="currentColor" />
                                                                    <path d="M8.82343 12.0064L8.08852 14.3348C7.8655 15.0414 8.46151 15.7366 9.19388 15.6242L11.8974 15.2092C12.4642 15.1222 12.6916 14.4278 12.2861 14.0223L9.98595 11.7221C9.61452 11.3507 8.98154 11.5055 8.82343 12.0064Z" fill="currentColor" />
                                                                </svg>
                                                                </span>
                                                                </Link>
                                                            </OverlayTrigger>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: getHelpers.NoDataFound() }}></div>
                    )
            }

        </div>
    )
}

export { RecentDashboards }
